"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledGrid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const Button_1 = require("../Button/Button");
const Layout_1 = require("../Layout");
exports.StyledGrid = (0, styled_components_1.default)(Layout_1.Grid) `
    width: 100%;
    background-color: ${tokens_1.COLOURS.primary.blue[130]};
    padding: ${tokens_1.SIZES[2]};
    box-sizing: border-box;
`;
// N.B. Can't do a normal styled(Button) here as it messes with the Jest tests ¯\_(ツ)_/¯
// see https://github.com/styled-components/styled-components/issues/1449
exports.StyledButton = (0, styled_components_1.default)((props) => (react_1.default.createElement(Button_1.Button, Object.assign({}, props)))) `
    justify-content: center;
    width: 100%;

    @media (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        width: fit-content;
    }
`;
//# sourceMappingURL=CookieBanner.styles.js.map